<template>
  <div class="side-menu">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
